export const findValue = (object, path = '') => {
  if (typeof object !== 'object' || path === '') return ''

  const parts = path.split('.')

  return parts.reduce((object, key) => object?.[key], object)
}

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
